import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {offboarding_template} from "../components/templates/offboarding_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class offboarding extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: offboarding_template;
    protected pagination: pagination_template;

    protected getModuleName(){

        return "offboarding";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        // create the offboarding users list
        this.elementsList = new offboarding_template("list", this.viewModel, this);

        //only show Add User button if CM or Admin
        let vnApp = this.getVnAppZone().app;
        let roles = vnApp.loggedUser.user.valnet_user.roles;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Offboarding List");

        return [this.elementsList.build()];
    }


    fillPage() : void{

        this.getFormData();
    }

    protected getFormData() {

        let token: string;
        let action: string;


        let validateReq_url: string = '/api/users/references/';
        let validateReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(validateReq_url, validateReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();

    }

    protected onGetFormDataReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                let userRoles = [{ id: 0, name: "All"}];

                for (let role of responseParsed.roles) {
                    userRoles.push({id: role.id, name: role.name});
                }

                obj.filterList();
            });
        }
    }

    protected viewUser(id){

        this.saveViewModule(this.getMemoryViewModel());
        page('/users/profile/'+id);
    }

    protected earningsUser(id){

        this.saveViewModule(this.getMemoryViewModel());
        page('/payment/earnings/'+id);
    }

    protected paginationOnPageClick(){

        this.filterList();
    }

    protected userListReorder(){

        this.filterList();
    }

    protected onShowActiveUsers() {

        this.filterList();
    }

    protected filterDropdownOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected getMemoryViewModel(){
        let templateViewModel = this.elementsList.getTemplateViewModel();

        delete templateViewModel.user;

        return templateViewModel;
    }

    protected filterList(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/users/offboarding';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){


        return function(){
            obj.manageResponse(req, obj, function(){

                //console.log(this.XHRHdl.reqestStartTime());

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });
            obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
        }
    }

    //
    // update the module list using the objects list
    protected updateList(responseParsed: any){

        // set users list
        let usersToSet = [];
        for (let item of responseParsed.paginatedResults.data) {

            let claimingTax = "";
            if (item.taxNumbers !== undefined && item.taxNumbers.length > 0){
                claimingTax = "YES";
            }

            usersToSet.push( {

                pictureUrl:  ((item.valnet_user.pictureUrl) ? item.valnet_user.pictureUrl : "/assets/images/default-user.png")
                ,fullName: item.valnet_user.fullName
                ,loginName: item.valnet_user.loginName
                ,email: item.valnet_user.email
                ,effectiveDate : item.effectiveDate.substring(0,10)
                ,currency: item.valnet_paymentInfo.currency.currency
                ,id : item.id
                ,claimingTax: claimingTax
            } )
        }

        this.elementsList.setUsers(usersToSet);

        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
        this.elementsList.setResultInfo(responseParsed.paginatedResults.totalCount, responseParsed.paginatedResults.totalPage,execTime );

        // update the paginator
        this.viewModel.list.pagination.itemCount(responseParsed.paginatedResults.totalCount);
    }

    protected getTransactionsForUser(id){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/transactions/offboarding';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())] );
        usrReq_params.push(["idUser", id]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onTransactionRequestReturn;
        this.XHRHdl.execute();
    }

    protected onTransactionRequestReturn(req, obj){


        return function(){
            obj.manageResponse(req, obj, function(){

                //console.log(this.XHRHdl.reqestStartTime());

                let responseParsed = JSON.parse(req.request.response);
                obj.elementsList.setTotal(responseParsed.total);
                obj.elementsList.setTransactions(responseParsed.transactions);
            });
            obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
        }
    }


    protected getProratedTransactionsForUser(id){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/transactions/offboarding';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())] );
        usrReq_params.push(["idUser", id]);
        usrReq_params.push(["prorated", "true"]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onProratedTransactionRequestReturn;
        this.XHRHdl.execute();
    }

    protected onProratedTransactionRequestReturn(req, obj){


        return function(){
            obj.manageResponse(req, obj, function(){

                //console.log(this.XHRHdl.reqestStartTime());

                let responseParsed = JSON.parse(req.request.response);
                obj.elementsList.setTotal(responseParsed.total);
                obj.elementsList.setTransactions(responseParsed.transactions);
            });
            obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
        }
    }
}


// WEBPACK FOOTER //
// ./js/modules/offboarding.ts